import React from 'react';
import UIButton from 'Components/UIComponents/UIButton';
import UIModal from 'Components/UIComponents/UIModal';
import { DocumentTypes } from 'Interfaces/Document';

const ApplyFontTexts = {
  [DocumentTypes.FORM_REQUEST]: 'form',
  [DocumentTypes.TEMPLATE]: 'template',
  [DocumentTypes.ME]: 'document',
  [DocumentTypes.ME_AND_OTHER]: 'document',
  [DocumentTypes.OTHERS]: 'document',
};

interface ApplyFontsModalProps {
  documentType?: DocumentTypes;
  onClose: () => void;
  onContinue: () => void;
}

const ApplyFontsModal = ({
  documentType = DocumentTypes.ME,
  onClose,
  onContinue,
}: ApplyFontsModalProps) => {
  return (
    <UIModal className="apply-modal" onClose={onClose}>
      <div className="apply-modal__title">Change Font Settings</div>
      <div className="apply-modal__description">
        {`Are you sure that you want to apply these settings to all the fields on the ${ApplyFontTexts[documentType]}?`}
      </div>
      <div className="apply-modal__buttons">
        <UIButton
          title="Yes"
          priority="primary"
          className="centered-text"
          handleClick={onContinue}
        />
        <UIButton
          title="No"
          priority="secondary"
          className="centered-text"
          handleClick={onClose}
        />
      </div>
    </UIModal>
  );
};

export default ApplyFontsModal;
